import { LOCAL_CONTROL_UNIT_API, LOCAL_NAVIGATION_API } from '@/constants'

function forceHTTP(url: string) {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`
  }

  return url
}

function getNavigationApiUrl(): string {
  return forceHTTP(LOCAL_NAVIGATION_API)
}

function getControlUnitApiUrl(): string {
  const override =
    import.meta.env.VITE_CONTROL_UNIT_API_URL ||
    (typeof window !== 'undefined' ? window.ENV?.CONTROL_UNIT_API_URL : undefined)

  return forceHTTP(override || LOCAL_CONTROL_UNIT_API)
}

export { getControlUnitApiUrl, getNavigationApiUrl }
